import { z } from "zod";

export const ExternalIdSchema = z.object({
  id: z.string().uuid().describe("ID"),
  business_id: z.string().uuid().describe("Business"),
  account_id: z.string().uuid().describe("Account"),
  entity_type: z.string().describe("Entity Type"),
  entity_id: z.string().uuid().describe("Entity"),
  source: z.string().describe("Source"),
  external_id: z.string().describe("External ID"),
  metadata: z.record(z.unknown()).nullable().describe("Metadata"),
  created_at: z.string().nullable().describe("Created At"),
  updated_at: z.string().nullable().describe("Updated At"),
});
export type ExternalId = z.infer<typeof ExternalIdSchema>;

export const ExternalIdEntrySchema = z.object({
  source: z.string().describe("Source"),
  external_id: z.string().describe("External ID"),
});
export type ExternalIdEntry = z.infer<typeof ExternalIdEntrySchema>;
